import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { ModalService } from '../modal/modal.service';

@Component({
    selector: 'mlp-ng-prompt',
    templateUrl: './prompt.component.html',
})

export class PromptSharedComponent {
    @ViewChild(TemplateRef) public template: TemplateRef<any>;

    @Input() title: string;
    @Input() description: string;

    constructor(public modalService: ModalService) {}
}
